import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonInput from '../button-input/ButtonInput';
import GridInput from '../grid-input/GridInput';
import TextArea from '../text-area/TextArea';
import Papa from 'papaparse';

export default class InputUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedFileText: null
    };
  }
  
  componentWillReceiveProps(newProps) {
    // For case where user is going from edit-mode to read-only-mode (like onCancel)
    // Also for case where changes happen to the existingContent so the uploadedFileText shouldn't overrule that
    if (
      (this.props.isEditable && !newProps.isEditable) || 
      (newProps.existingContent !== this.props.existingContent)) {
      // The input needs to default back to the existing content (aka the last save), so the uploaded text needs to be cleared out
      this.setState({ uploadedFileText: null });
    }
  }
  
  getValue = () => {
    return this[this.props.id].getValue();
  }
  
  uploadFile = (file) => {
    let reader = new FileReader();
    
    reader.onload = (e) => {
      this.setState((prevState) => {
        let uploadedFileText = e.target.result.trim();
        
        return { uploadedFileText }
      });
    };
    
    reader.readAsText(file);
  }
  
  render() {  
    let buttonDisplay = (this.props.isEditable) &&
      <ButtonInput 
        className="button--small field"
        value={this.props.buttonLabel}
        onClick={this.uploadFile}
        type="file-button"
        id={this.props.id + '-file-upload-button'}
        fileTypes={this.props.fileTypes}
        verticalSpacing={this.props.verticalSpacing}
      />;
    
    let parsedExistingContent = (this.props.hasGrid && this.props.existingContent) ?
      Papa.parse(this.props.existingContent.trim()).data : 
      null;
    
    let inputDisplayProps = {
      id: this.props.id,
      isEditable: (!this.props.isEditable) ? false : undefined,
      label: this.props.label,
      ref: instance => { this[this.props.id] = instance; },
      verticalSpacing: this.props.verticalSpacing
    };
    
    let inputDisplay = (this.props.hasGrid) ?
      <GridInput
        {...inputDisplayProps}
        existingContentArray={(this.state.uploadedFileText) ? Papa.parse(this.state.uploadedFileText).data : parsedExistingContent}
      /> :
      <TextArea
        {...inputDisplayProps}
        existingContent={(this.state.uploadedFileText) ? this.state.uploadedFileText : this.props.existingContent}
      />;
    
    return (
      <div>
        {inputDisplay}
        {buttonDisplay}
      </div>
    );
  }
}

InputUpload.defaultProps = {
  hasGrid: false,
  isEditable: true
};

InputUpload.propTypes = {
  buttonLabel: PropTypes.string,
  existingContent: PropTypes.string,
  fileTypes: PropTypes.string,
  hasGrid: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  verticalSpacing: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/shared/components/presentation/input-upload/InputUpload.js